var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_vm._m(0), _c('section', {
    staticClass: "section container"
  }, [_c('p', {
    staticClass: "px-3"
  }, [_c('center', [_c('h10', {
    staticClass: "text-center"
  }, [_c('sup', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('b', [_vm._v("LIVE")])]), _vm._v(" Project Spectrum will be livestreaming from the Mentor Protege Summit 2023 in Orlando, FL on Wednesday, 29 March, starting at 9:00 AM EDT. During our session, Program Manager Kareem Sykes will speak to attendees about Project Spectrum's efforts to bolster cybersecurity for manufacturing and industry, including new and upcoming initiatives for the platform. We'll be showing other bits and bytes from the summit, so tune in! ")])], 1)], 1), _c('div', [_c('video-player', {
    attrs: {
      "options": _vm.videoOptions
    }
  })], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "inner-header-bg"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section-breadcrumb"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 justify-content-center align-self-center pb-2"
  }, [_c('div', {
    staticClass: "breadcrumb-content"
  }, [_c('div', {
    staticClass: "title-section"
  }, [_c('h1', {
    staticClass: "title text-center text-white"
  }, [_vm._v(" Live Stream ")])]), _c('div', {
    staticClass: "breadcrumb-nav"
  }, [_c('ul', {
    staticClass: "breadcrumb-link text-center list-unstyled mb-0"
  }, [_c('li', {
    staticClass: "text-white"
  }, [_c('i', {
    staticClass: "mdi mdi-home theme-light-color pr-2"
  }), _c('a', {
    attrs: {
      "href": "/#/"
    }
  }, [_vm._v("Home")])]), _c('li', {
    staticClass: "theme-light-color active"
  }, [_vm._v(" Live Stream ")])])])])])])])])])]);

}]

export { render, staticRenderFns }